export const semestreCursoNormalize = (x) => ({
    idSemestreCurso: x.idSemestreCurso ?? x.IdSemestreCurso ?? 0,
    idSemestre: x.idSemestre ?? x.IdSemestre ?? 0,
    idCurso: x.idCurso ?? x.IdCurso ?? 0,
    activo: x.activo ?? x.Activo ?? true,
});
